var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('input',{staticStyle:{"position":"fixed","top":"-1000px","left":"-1000px"},attrs:{"id":"hidden-input","type":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }